import { PrintView } from '../../components/PrintView/print-view.component';

// Calculation helpers
export const calculateTotal = (arr, maxScore) => {
  const sum = arr.reduce((acc, v) => acc + (parseFloat(v) || 0), 0);
  return ((sum / (arr.length * 10)) * maxScore).toFixed(2);
};

export const calculateSBA = (ce10, hw10) =>
  (((parseFloat(ce10) + parseFloat(hw10)) / 20) * 10).toFixed(2);

export const calculateTotalMarks = (sba10, catsArr, project) => {
  const catsSum = catsArr.reduce((acc, v) => acc + (parseFloat(v) || 0), 0);
  return (parseFloat(sba10) + catsSum + (parseFloat(project) || 0)).toFixed(2);
};

export const calculateFinalPercentage = (total60) =>
  ((parseFloat(total60) / 60) * 50).toFixed(2);

export const SBAAbbreviationsNote = () => {
  return (
    <PrintView>
      <div className=" text-12 text-grey" style={{ lineHeight: 1.5 }}>
        <p className="font-bold text-dark">Note:</p>
        <ul style={{ listStyle: 'disc', marginLeft: 20 }}>
          <li>C.E. - Class Exercise</li>
          <li>H/W - Homework</li>
          <li>CATS - Class Assessment Tests</li>
          <li>SBA - Standards-Based Assessment</li>
        </ul>
      </div>
    </PrintView>
  );
};
